import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from './views/Dashboard.vue';
import Platforms from './views/Platforms.vue';
import NewPlatform from './views/NewPlatform.vue';
import EditPlatform from './views/EditPlatform.vue';
import Helpdesk from './views/Helpdesk.vue';
import TeamTasks from './views/TeamTasks.vue';
import Task from './views/Task.vue';
import Users from './views/Users.vue';
import NewUser from './views/NewUser.vue';
import EditUser from './views/EditUser.vue';
import Stat from './views/Stat.vue';
import StatServers from './views/StatServers.vue';
import StatHelpdesk from './views/StatHelpdesk.vue';
import StatCommon from './views/StatCommon.vue';
import StatPlatforms from './views/StatPlatforms.vue';
import BaseNested from './views/BaseNested.vue';
import Handbooks from './views/Handbooks.vue';
import Tags from './views/Tags.vue';
import Cron from './views/Cron.vue';
import CronTasks from './views/CronTasks.vue';
import NewCronTask from './views/NewCronTask.vue';
import EditCronTask from './views/EditCronTask.vue';
import CronSettings from './views/CronSettings.vue';
import CronStatistics from './views/CronStatistics.vue';
import store from '@/store';

const route = (path, name, component, config) => ({
  path,
  name,
  component,
  ...config,
});

Vue.use(Router);

const router = new Router({
  // mode: "history",
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active',

  routes: [
    route('', 'home', null, {
      redirect: { name: 'helpdesk' },
    }),

    route('/dashboard', 'dashboard', Dashboard, {
      meta: { group: 'dashboard', title: 'Dashboard' },
    }),

    route('/platforms', null, BaseNested, {
      meta: { group: 'platforms', title: 'Платформы' },
      children: [
        route('', 'platforms', Platforms),
        route('create', 'newPlatform', NewPlatform),
        route(':id/edit', 'editPlatform', EditPlatform),
      ],
    }),

    route('/helpdesk', null, BaseNested, {
      meta: { group: 'helpdesk', title: 'Хелпдеск', public: true },
      children: [
        route('', 'helpdesk', Helpdesk),
        route('task/create', 'newTask', Task),
        route('task/:id/edit', 'editTask', Task),
        route('task/:id', 'task', Task),
      ],
    }),

    route('/team', null, BaseNested, {
      meta: { group: 'team', title: 'Задачи сотрудников', public: false },
      children: [
        route('', 'team', TeamTasks),
      ],
    }),

    route('/stat', 'stat', Stat, {
      meta: { group: 'stat', title: 'Статистика', public: false },
      redirect: { name: 'statHelpdesk' },
      children: [
        route('common', 'statCommon', StatCommon),
        route('helpdesk', 'statHelpdesk', StatHelpdesk),
        route('platforms', 'statPlatforms', StatPlatforms),
        route('server', 'statServers', StatServers),
      ],
    }),

    route('/users', null, BaseNested, {
      meta: { group: 'users', title: 'Пользователи' },
      children: [
        route('', 'users', Users),
        route('create', 'newUser', NewUser),
        route(':id/edit', 'editUser', EditUser),
      ],
    }),

    route('/handbooks', 'handbooks', Handbooks, {
      meta: { group: 'handbooks', title: 'Справочники'},
      redirect: { name: 'tags' },
      children: [route('tags', 'tags', Tags)],
    }),

    route('/cron', 'cron', Cron, {
      meta: { group: 'cron', title: 'Планировщик задач'},
      redirect: { name: 'cronTasks' },
      children: [
        route('tasks', 'cronTasks', CronTasks),
        route('tasks/create', 'newCronTask', NewCronTask),
        route('tasks/:id/edit', 'editCronTask', EditCronTask),
        route('settings', 'cronSettings', CronSettings),
        route('statistics', 'cronStatistics', CronStatistics),
      ],
    }),
  ],

  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const isPublicRoute = to.matched.some(({ meta }) => meta && meta.public);

  if (!isPublicRoute && !store.getters.user.isSupport) {
    return next({ name: 'helpdesk' });
  }

  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(({ meta }) => meta && meta.title);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  next();
});

export default router;
